export const calculateLumpSumSettlement = (payload, taxInformationData) => {
  const nextPayload = { ...payload };

  const totalSettlement = parseFloat(nextPayload["Gross Monthly Wages"] || 0);
  const legalFees = parseFloat(nextPayload["Legal Fees Incurred"] || 0);
  const settlementBasis = nextPayload["Settlement Basis"];
  const paymentType = nextPayload["Payment Type"];

  // 1. Duration & Structured Calculation
  const startDate = nextPayload["Date Income Starts"] ? new Date(nextPayload["Date Income Starts"]) : null;
  const endDate = nextPayload["Date Income Ends"] ? new Date(nextPayload["Date Income Ends"]) : null;
  
  let durationYears = 1;
  if (startDate && endDate && endDate > startDate) {
    durationYears = (endDate - startDate) / (1000 * 60 * 60 * 24 * 365.25);
  }

  // Formula: If "Structured," multiply the "Total Amount" by the number of years
  if (paymentType && paymentType.includes("Structured")) {
    nextPayload["Total Settlement Liability"] = parseFloat((totalSettlement * durationYears).toFixed(2));
  } else {
    nextPayload["Total Settlement Liability"] = totalSettlement;
  }

  // 2. Taxability Logic based on Settlement Basis (2026 OBBBA Rules)
  let amountSubjectToTax = 0;
  let federalTaxType = "Ordinary Income";
  let stateTaxType = "Ordinary Income";
  let ficaTax = 0;

  switch (settlementBasis) {
    case "Personal Physical Injury (Tax-Free)":
      amountSubjectToTax = 0;
      federalTaxType = "Tax-Free (e.g., VA Disability)";
      stateTaxType = "Tax Free";
      break;

    case "Punitive Damages (Fully Taxable)":
      amountSubjectToTax = totalSettlement;
      federalTaxType = "Fully Taxable (Ordinary Income) (e.g., W-2, Traditional Pension)";
      stateTaxType = "Ordinary Income";
      break;

    case "Emotional Distress (Partially Taxable)":
      // Rule: Total Settlement - Unreimbursed Medical Expenses. 
      // Note: Medical Expenses field not provided in JSON, defaulting to 0 deduction.
      amountSubjectToTax = totalSettlement; 
      federalTaxType = "Partially Taxable (Social Security Rules)";
      stateTaxType = "Ordinary Income";
      break;

    case "Back Pay / Severance (W-2 Income)":
      // Rule: Total Settlement - Attorney Fees (Legal Fees)
      amountSubjectToTax = Math.max(0, totalSettlement - legalFees);
      federalTaxType = "Fully Taxable (Ordinary Income) (e.g., W-2, Traditional Pension)";
      stateTaxType = "Ordinary Income";

      // FICA Formula (2026): 7.65% up to Social Security Wage Base Cap ($184,500)
      const ssWageBaseCap = 184500;
      const ssTaxable = Math.min(amountSubjectToTax, ssWageBaseCap);
      const ssTax = ssTaxable * 0.062;
      const medicareTax = amountSubjectToTax * 0.0145;
      ficaTax = parseFloat((ssTax + medicareTax).toFixed(2));
      break;

    default:
      amountSubjectToTax = totalSettlement;
      break;
  }

  nextPayload["Amount Subject to Federal Taxation"] = parseFloat(amountSubjectToTax.toFixed(2));
  nextPayload["Federal Taxation Type"] = federalTaxType;
  nextPayload["State Taxation Type"] = stateTaxType;

  // 3. Tax Estimation & Net Amount Formula
  let fedTax = 0;
  let stateTax = 0;

  if (amountSubjectToTax > 0 && taxInformationData) {
    const fedRate = parseFloat(taxInformationData["Federal Tax Rate"] || 0) / 100;
    const stateRate = parseFloat(taxInformationData["State Tax Effective Rate"] || 0) / 100;
    
    fedTax = amountSubjectToTax * fedRate;
    stateTax = amountSubjectToTax * stateRate;
  }

  // Net = Total Settlement - (Calculated Federal Tax + Calculated State Tax + FICA)
  const netAmount = totalSettlement - (fedTax + stateTax + ficaTax);
  nextPayload["Net Amount"] = parseFloat(netAmount.toFixed(2));

  return nextPayload;
};

export const getLumpSumSettlementConfig = (name) => {
  const config = {
    "Gross Monthly Wages": { label: "Total Settlement Amount" },
    "Payment Type": { label: "Payment Type" },
    "Settlement Basis": { label: "Settlement Basis" },
    "Legal Fees Incurred": { label: "Legal Fees Incurred" },
    "Amount Subject to Federal Taxation": { readOnly: true },
    "Net Amount": { label: "Net Amount (After Tax)", readOnly: true },
    "Total Settlement Liability": { readOnly: true },
    
    // Disable/Remove requested fields
    "Passive or Active": { delete: true },
    // "Adjusted Gross Income (AGI)": { delete: true },
    // "% Yearly Increase": { delete: true },
    // "Income Source From Asset": { delete: true },
    // "Notes": { delete: true },
    // "Already Earning Income": { delete: true },
    // "No End Date": { delete: true },
    // "Frequency of Pay Periods": { delete: true },
    "Amount Subject to Federal Taxation": { readOnly: true },
  };
  return config[name] || {};
};

export const getLumpSumSettlementGroupPrefix = (groupName) => {
  if (groupName === "INCOME DETAILS") return "Part A: ";
  if (groupName === "TAXATION") return "Part B: ";
  return "";
};
